//过滤器
// export function toThousandslsFilter(num) {
//     return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
// }

export function addbrackets(value) {
  value = '(' + value + ')';
  return value
}
// 预览，点赞，评论，收藏数字格式化
export function changeNumber(intNumber) {
  let str = ''
  if (Number(intNumber) > 10000) {
    let allnum = Number(intNumber) / 10000
    str = allnum.toFixed(2) + 'w'
  } else {
    str = Number(intNumber)
  }
  return str
}



// WEBPACK FOOTER //
// ./src/filters/index.js